import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { GATEWAY_ROUTES, GATEWAY_SELECTION_TYPES } from "constant/gateway";

interface AddGatewayDropdownProps {
    className?: string;
    variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
    size?: "sm" | "lg";
    disabled?: boolean;
    "aria-label"?: string;
    "data-testid"?: string;
}

export const AddGatewayDropdown: React.FC<AddGatewayDropdownProps> = ({
    className = "mr-3",
    variant = "primary",
    size,
    disabled = false,
    "aria-label": ariaLabel = "Add Gateway Options",
    "data-testid": testId = "add-gateway-dropdown",
}) => {
    return (
        <Dropdown className={className} data-testid={testId}>
            <Dropdown.Toggle
                variant={variant}
                size={size}
                disabled={disabled}
                className="add-gateway"
                bsPrefix="btn"
                aria-label={ariaLabel}
                aria-haspopup="true"
                aria-expanded="false"
            >
                + ADD GATEWAY
            </Dropdown.Toggle>
            <Dropdown.Menu role="menu">
                <Dropdown.Item
                    as={Link}
                    to={GATEWAY_ROUTES.IOTPORTAL_ADD}
                    role="menuitem"
                    data-testid="iotportal-option"
                >
                    {GATEWAY_SELECTION_TYPES.IOTPORTAL}
                </Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    to={GATEWAY_ROUTES.LORAWAN_ADD}
                    role="menuitem"
                    data-testid="lorawan-option"
                >
                    {GATEWAY_SELECTION_TYPES.LORAWAN}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default AddGatewayDropdown;